/**
 * «Понял так» — наше понимание фразы, показанное человеку до сохранения.
 *
 * Зачем. Человек пишет «бэкэнд плюс создание лэндингов» и получает ноль
 * заказов, не понимая почему. Мы перестаём угадывать молча: показываем, что
 * именно поняли, и даём убрать лишнее. Это и страховка от ошибки модели,
 * и ответ на вопрос «понимают ли меня вообще».
 *
 * Лишние услуги не выкидываем молча: на free-тарифе ниша одна, поэтому
 * вторую называем честно и говорим, где она откроется.
 */
export function UnderstandingBlock({
  understanding,
  removed = [],
  onToggle,
  plan = "free",
}) {
  if (!understanding?.niche) return null;
  const aliases = understanding.aliases || [];
  const aliasKeys = new Set(aliases.map(normalizedTerm));
  const extra = (understanding.extra || []).filter((value) => !aliasKeys.has(normalizedTerm(value)));
  const убрано = new Set(removed);

  return (
    <section className="understanding" aria-label="Что мы поняли">
      <p className="type-meta">Понял так</p>
      <h4 className="understanding__niche">{understanding.niche}</h4>

      {aliases.length ? (
        <>
          <p className="understanding__hint">
            Ищу ещё и так — уберите лишнее, если промахнулся:
          </p>
          <ul className="understanding__chips">
            {aliases.map((alias) => {
              const выключен = убрано.has(alias);
              return (
                <li key={alias}>
                  <button
                    type="button"
                    className={выключен ? "is-off" : ""}
                    aria-pressed={!выключен}
                    onClick={() => onToggle?.(alias)}
                  >
                    {alias}
                    <span aria-hidden="true">{выключен ? "+" : "×"}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </>
      ) : null}

      {extra.length ? (
        <p className="understanding__extra">
          Вы назвали ещё: <strong>{extra.join(", ")}</strong>.{" "}
          {plan === "free"
            ? "Это отдельная услуга — вторую можно добавить на Pro."
            : "Добавьте её отдельной услугой в настройках поиска."}
        </p>
      ) : null}
    </section>
  );
}

function normalizedTerm(value) {
  return String(value)
    .toLocaleLowerCase("ru-RU")
    .replaceAll("ё", "е")
    .replace(/[^a-zа-я0-9]+/gi, " ")
    .trim()
    .replace(/\s+/g, " ");
}

/** Какие синонимы уходят на сервер: всё понятое минус снятое человеком. */
export function keptAliases(understanding, removed = []) {
  const убрано = new Set(removed);
  return (understanding?.aliases || []).filter((alias) => !убрано.has(alias));
}
